import { getProductTitle } from '@/src/app/(base)/products/[slug]/utils/getProductTitle';
import { Box } from '@/src/packages/components/ui/Box';
import { useProductCardContext } from '@/src/packages/components/ui/ProductCard/ProductCardContext';
import { cn } from '@/src/packages/utils/cn';
import Image from 'next/image';
import { useState } from 'react';

export const ProductCardImage = () => {
  const {
    productVariant: {
      images,
      product: { title },
      productOptionValue,
    },
  } = useProductCardContext();

  const imageMain = images[0];

  const imageHover = images[1];

  const [isHovered, setHovered] = useState(false);

  return (
    <Box
      className="relative aspect-square"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Box className="absolute top-0 left-0 h-full w-full overflow-hidden z-[1]">
        <Image
          src={imageHover.fields.file.url}
          alt={getProductTitle(title, productOptionValue?.name)}
          fill
          sizes="(max-width: 1024px) 100vw, 50vw"
          className={cn(
            'transition-all duration-300 object-cover transform scale-[1.02] group-hover:scale-100',
            {
              'opacity-100': isHovered,
              'opacity-0': !isHovered,
            }
          )}
        />
      </Box>

      <Image
        src={imageMain.fields.file.url}
        alt={getProductTitle(title, productOptionValue?.name)}
        fill
        sizes="(max-width: 1024px) 100vw, 50vw"
      />
    </Box>
  );
};
